import { createFileRoute, redirect } from '@tanstack/react-router';

// Dashboard route - redirects to app for all users
export const Route = createFileRoute('/dashboard')({
  beforeLoad: () => {
    throw redirect({ to: '/app' });
  },
  component: () => null,
});
